import { getPropToken, getPropTokenVanilla } from './getPropToken.js';

const getVariantToken = (componentKey, key, variant, appearance) => getPropToken(componentKey, key, 'variant', variant, appearance);
const getVariantTokenVanilla = (theme, componentKey, key, variant, appearance) => getPropTokenVanilla(theme, componentKey, key, 'variant', variant, appearance);

export { getVariantToken, getVariantTokenVanilla };
//# sourceMappingURL=getVariantToken.js.map
